export default __webpack_public_path__ + "static/media/GIF_blue.633dcc9f.svg";